// =============================================================================
// PEDIGREE ZOOM SERVICE
// =============================================================================

import {
	defaultViewport,
} from '../pedigree-constants';

export class PedigreeZoomService {

	constructor(pedigreeWrapper) {
		this.pedigreeWrapper = pedigreeWrapper
	}

	handleZoomTo(zoom_val) {
		this.pedigreeWrapper.reactFlowInstance.zoomTo(zoom_val);
		this.pedigreeWrapper.updateZoomValue(null, { zoom: zoom_val })
	}

	handleZoomInClick() {
		const z = PedigreeZoomService.curatedZoom();
		this.handleZoomTo(PedigreeZoomService.nextZoom(z, 'up'));
	}

	handleZoomOutClick() {
		const z = PedigreeZoomService.curatedZoom();
		this.handleZoomTo(PedigreeZoomService.nextZoom(z, 'down'));
	}

	handleActualSizeClick() {
		this.handleZoomTo(defaultViewport.zoom);
	}

	handleFitToScreenClick() {
		this.pedigreeWrapper.reactFlowInstance.fitView({ padding: 0.4 });
		this.pedigreeWrapper.updateZoomValue(null, { zoom: this.pedigreeWrapper.reactFlowInstance.getZoom() });
	}

	static curatedZoom(zoom) {
		// 20% - 0.21     // 120% - 1.26
		// 30% - 0.32     // 130% - 1.36
		// 40% - 0.42     // 140% - 1.47
		// 50% - 0.53     // 150% - 1.57
		// 60% - 0.63     // 160% - 1.68
		// 70% - 0.74     // 170% - 1.78
		// 80% - 0.84     // 180% - 1.89
		// 90% - 0.95     // 190% - 1.99
		// 100% - 1.05    // 200% - 2.1
		// 110% - 1.15    // 210% - 2.2
		if (zoom >= 0.2 && zoom <= 0.26) {
			return 0.21;
		} else if (zoom > 0.26 && zoom <= 0.37) {
			return 0.32;
		} else if (zoom > 0.37 && zoom <= 0.47) {
			return 0.42;
		} else if (zoom > 0.47 && zoom <= 0.58) {
			return 0.53;
		} else if (zoom > 0.58 && zoom <= 0.68) {
			return 0.63;
		} else if (zoom > 0.68 && zoom <= 0.79) {
			return 0.74;
		} else if (zoom > 0.79 && zoom <= 0.89) {
			return 0.84;
		} else if (zoom > 0.89 && zoom <= 1.0) {
			return 0.95;
		} else if (zoom > 1.0 && zoom <= 1.1) {
			return 1.05;
		} else if (zoom > 1.1 && zoom <= 1.2) {
			return 1.15;
		} else if (zoom > 1.2 && zoom <= 1.31) {
			return 1.26;
		} else if (zoom > 1.31 && zoom <= 1.41) {
			return 1.36;
		} else if (zoom > 1.41 && zoom <= 1.52) {
			return 1.47;
		} else if (zoom > 1.52 && zoom <= 1.62) {
			return 1.57;
		} else if (zoom > 1.62 && zoom <= 1.73) {
			return 1.68;
		} else if (zoom > 1.73 && zoom <= 1.83) {
			return 1.78;
		} else if (zoom > 1.83 && zoom <= 1.94) {
			return 1.89;
		} else if (zoom > 1.94 && zoom <= 2.04) {
			return 1.99;
		} else if (zoom > 2.04 && zoom <= 2.15) {
			return 2.1;
		} else if (zoom > 2.15 && zoom <= 2.2) {
			return 2.2;
		}
	}

	static nextZoom(zoom, direction) {
		switch (zoom) {
			case 0.21:
				if (direction === 'up') {
					return 0.32;
				} else {
					return 0.21;
				}
			case 0.32:
				if (direction === 'up') {
					return 0.42;
				} else {
					return 0.21;
				}
			case 0.42:
				if (direction === 'up') {
					return 0.53;
				} else {
					return 0.32;
				}
			case 0.53:
				if (direction === 'up') {
					return 0.63;
				} else {
					return 0.42;
				}
			case 0.63:
				if (direction === 'up') {
					return 0.74;
				} else {
					return 0.53;
				}
			case 0.74:
				if (direction === 'up') {
					return 0.84;
				} else {
					return 0.63;
				}
			case 0.84:
				if (direction === 'up') {
					return 0.95;
				} else {
					return 0.74;
				}
			case 0.95:
				if (direction === 'up') {
					return 1.05;
				} else {
					return 0.84;
				}
			case 1.05:
				if (direction === 'up') {
					return 1.15;
				} else {
					return 0.95;
				}
			case 1.15:
				if (direction === 'up') {
					return 1.26;
				} else {
					return 1.05;
				}
			case 1.26:
				if (direction === 'up') {
					return 1.36;
				} else {
					return 1.15;
				}
			case 1.36:
				if (direction === 'up') {
					return 1.47;
				} else {
					return 1.26;
				}
			case 1.47:
				if (direction === 'up') {
					return 1.57;
				} else {
					return 1.36;
				}
			case 1.57:
				if (direction === 'up') {
					return 1.68;
				} else {
					return 1.47;
				}
			case 1.68:
				if (direction === 'up') {
					return 1.78;
				} else {
					return 1.57;
				}
			case 1.78:
				if (direction === 'up') {
					return 1.89;
				} else {
					return 1.68;
				}
			case 1.89:
				if (direction === 'up') {
					return 1.99;
				} else {
					return 1.78;
				}
			case 1.99:
				if (direction === 'up') {
					return 2.1;
				} else {
					return 1.89;
				}
			case 2.1:
				if (direction === 'up') {
					return 2.2;
				} else {
					return 1.99;
				}
			case 2.2:
				if (direction === 'up') {
					return 2.2;
				} else {
					return 2.1;
				}
			default:
				return zoom;
		}
	}
}